import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { WebViewerInstance } from "@pdftron/webviewer";
import { IdexService } from "app/idex.service";
import { AppLoaderComponent } from "app/shared/app-loader/app-loader.component";
import { InsertMergeFilesComponent } from "../insert-merge-files/insert-merge-files.component";

export async function insertFile(
        instance: WebViewerInstance,
        dialog: MatDialog,
        service: IdexService,
        loader?: AppLoaderComponent,
    ) {
        const doc = instance?.Core.documentViewer.getDocument();
        const pageIndexToInsert = instance?.Core.documentViewer.getCurrentPage() + 1;
        const LIMIT_UPLOAD_SIZE_BYTE = await service.get('upload/limitsize').toPromise();
        const dialogRef = dialog.open(
            InsertMergeFilesComponent,
            {
                disableClose: true,
            }
        );
        dialogRef.componentInstance.LIMIT_UPLOAD_SIZE_BYTE = LIMIT_UPLOAD_SIZE_BYTE;

        dialogRef.afterClosed().subscribe(async (res: FileList) => {
            // If the user press cancel, 'res' will be 'undefined'
            if(!res) return;

            loader?.show();
            doc.mergeDocument(res[0], pageIndexToInsert).then(() => { });
            instance?.Core.documentViewer.refreshAll();
            loader?.hide();
        });
}
